import {contractSha256} from '../../../../packages/gaming-sdk/src/generated/digest';
export type GamingTelemetryEvent='prepare'|'wss-verified'|'studio-marker'|'player-commit'|'player-fallback';
export type GamingCorrelation={sessionId:string;epoch:number;transitionId:string};
export type GamingTelemetryRecord=Readonly<GamingCorrelation&{event:GamingTelemetryEvent;contractDigest:string;count?:number}>;
export type GamingTelemetrySink=(event:GamingTelemetryRecord)=>void;
const events=new Set<GamingTelemetryEvent>(['prepare','wss-verified','studio-marker','player-commit','player-fallback']);
const uuid=/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
/** No buffer, payload spread, exception serialization or authority. Sink failure is inert. */
export function createGamingTelemetry(sink:GamingTelemetrySink=event=>console.info('[gaming]',event)){
 return (event:GamingTelemetryEvent,binding:GamingCorrelation,fields?:{count?:number})=>{
  try{
   if(!events.has(event)||!uuid.test(binding.sessionId)||!uuid.test(binding.transitionId)||!Number.isSafeInteger(binding.epoch)||binding.epoch<0)return;
   const record:GamingTelemetryRecord=Object.freeze({event,sessionId:binding.sessionId,epoch:binding.epoch,transitionId:binding.transitionId,contractDigest:contractSha256,...(Number.isSafeInteger(fields?.count)&&fields!.count!>=0&&fields!.count!<=1000000?{count:fields!.count}: {})});
   sink(record);
  }catch{/* Observability must never interrupt the conventional programme. */}
 };
}
